







import { Component, Prop, Vue } from "vue-property-decorator";
import { normalizeCode } from "./code";

@Component({})
export default class CodeEntry extends Vue {
    @Prop()
    value: string;

    mounted() {
        const input = <HTMLInputElement>this.$refs.input;
        input.addEventListener("focus", () => document.body.classList.add("in-input"));
        input.addEventListener("blur", () => document.body.classList.remove("in-input"));
    }

    changed(ev: Event) {
        const input = <HTMLInputElement>ev.target;
        const code = normalizeCode(input.value);

        // Show the code in capitals, without anything that isn't part of it.
        if (input.value !== code) input.value = code;
        this.$emit("input", code);
    }
}
